export const setupEventos = () => {
  if (
    document.body.classList.contains("single-evento") ||
    document.body.classList.contains("congresos")
  ) {
    const links = document.querySelectorAll(".noticia");

    links.forEach((link) => {
      const url = link.querySelectorAll("a");
      url.forEach((url) => (url.href = "/page-evento.html"));
      link.addEventListener("click", () => {
        window.location.href = "/page-evento.html";
      });
    });
  }

  if (document.body.classList.contains("home-industria")) {
    const congresosCarrousel = document.querySelector(".eventos");

    const links = congresosCarrousel.querySelectorAll(".noticia");

    links.forEach((link) => {
      const url = link.querySelectorAll("a");
      url.forEach((url) => (url.href = "/page-evento.html"));
      link.addEventListener("click", () => {
        window.location.href = "/page-evento.html";
      });
    });
  }
};
